"use client";
import { InfoCircleOutlined } from "@ant-design/icons";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import { Col, Form, Input, Row, Select, Tooltip } from "antd";
// import countriesData from "../../../../../config/data/countries.json";

const IssuerDetails = (props) => {
  const {
    onFinish,
    form,
    initialValues,
    issuerTypeOptions,
    creditRatingOptions,
    countriesOptions,
  } = props;

  return (
    <div>
      <h1
        style={{
          fontSize: "24px",
          fontWeight: "bold",
          margin: 0,
          marginBottom: "24px",
        }}
      >
        Issuer Details
      </h1>

      <Form
        className="custom-form"
        layout="vertical"
        onFinish={onFinish}
        form={form}
        initialValues={initialValues}
        style={{ width: "100%" }}
      >
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Issuer Name
                  <Tooltip title="Select issuer name">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="issuerName"
              rules={[
                {
                  required: true,
                  message: "Please select issuer name",
                },
              ]}
            >
              <Input
                className="bond-input"
                style={{ height: 44 }}
                placeholder="Enter issuer name"
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Issuer Type
                  <Tooltip title="Select the issuer type">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="issuerType"
              rules={[
                {
                  required: true,
                  message: "Please select issuer type",
                },
              ]}
            >
              <Select
                placeholder="Select issuer type"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={issuerTypeOptions}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Credit Rating (Fitch)
                  <Tooltip title="Select the credit rating">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="creditRating"
              rules={[
                {
                  required: true,
                  message: "Please select credit rating",
                },
              ]}
            >
              <Select
                placeholder="Select credit rating"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={creditRatingOptions}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Country of Issue
                  <Tooltip title="Select the country where bond is issued">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="country"
              rules={[
                {
                  required: true,
                  message: "Please select country of issue",
                },
              ]}
            >
              <Select
                options={countriesOptions}
                placeholder={"Select country where bond is issued"}
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                showSearch
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default IssuerDetails;
